module.exports = __webpack_public_path__ + "img/gerejatua.7d42e6f8.jpeg";